import { Flex, IconButton, Tooltip } from '@aloft/toolkit-sui';

export const CreateOrderButton = ({
  isTooltipAlwaysOpen,
  onClick,
}: {
  isTooltipAlwaysOpen: boolean;
  onClick: () => void;
}) => (
  <Flex position="absolute" top="8rem" left=".5rem" zIndex={2}>
    <Tooltip
      defaultIsOpen={isTooltipAlwaysOpen}
      label="Click to create a new order"
      placement="bottom-end"
      hasArrow
    >
      <IconButton
        id="create-new-order-btn"
        data-testid="create-new-order-btn"
        ariaLabel="add order"
        icon="add"
        iconSize="lg"
        variant="primary"
        size="md"
        isRound
        onClick={onClick}
      />
    </Tooltip>
  </Flex>
);
